import { Directive } from "vue";
import Sticky from "sticky-js";
import { nanoid } from "nanoid";

type AppStickyElement = HTMLElement & {
    __app_sticky?: {
        update: (...args: unknown[]) => void;
        destroy: (...args: unknown[]) => void;
    };
    __app_sticky_disposer?: () => void;
};

type AppStickyOptions = undefined | { enabled: boolean };

const createOrUpdateSticky = (el: AppStickyElement, opts: AppStickyOptions) => {
    if (opts?.enabled === false) {
        if (el.__app_sticky_disposer) {
            el.__app_sticky_disposer();
        }
        return;
    }

    if (el.__app_sticky) {
        try {
            el.__app_sticky?.update();
        } catch {}
    } else {
        const identifier = "app_sticky_" + nanoid();

        el.setAttribute("data-app-sticky-id", identifier);

        el.__app_sticky = new Sticky(`[data-app-sticky-id=${identifier}]`);

        const updateSticky = () => {
            el.parentElement?.style.removeProperty("width");
            try {
                el.__app_sticky?.update();
            } catch {}
        };

        window.addEventListener("resize", updateSticky);

        el.__app_sticky_disposer = () => {
            try {
                el.__app_sticky?.destroy();
            } catch {}
            window.removeEventListener("resize", updateSticky);
        };
    }
};

export const appStickyDirective: Directive<AppStickyElement, AppStickyOptions> = {
    mounted(el, bindings) {
        // createOrUpdateSticky(el, bindings.value);
    },
    unmounted(el) {
        try {
            if (el.__app_sticky_disposer) {
                el.__app_sticky_disposer();
            }
        } catch {}
    },
    updated(el, bindings) {
        // createOrUpdateSticky(el, bindings.value);
    },
};
